import axios from 'axios'
import env from '../env'

export default class CommonAPI {
  static async uploadImg (para: any) {
    const Url: string = `${env.JMOBILE}/imageUpload/productUpload`
    return axios.post(Url, para, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }

  static async getEatTypeAndChannel () {
    const Url: string = `${env.JMOBILE}/channel/getEatTypeAndChannel`
    return axios.post(Url, {
      language: Config.i18n
    })
  }
}
